import React from 'react';
import { useAssignImportsOfferStore } from 'modules/Common/stores/assignImportsOfferStore';
import UploadAssignImportsDialog from './UploadAssignImportsDialog';

/** Shows the step a flow offered through `offerImportAssignment`. Mounted once. */
export default function AssignImportsOfferHost() {
  const { sections, setSections, close } = useAssignImportsOfferStore();
  if (!sections) return null;
  return (
    <UploadAssignImportsDialog
      show
      sections={sections}
      onSectionsChange={setSections}
      onDone={close}
    />
  );
}
